import {
  XVIFloatInputRendererComponent,
  XVIInventoryCountRendererComponent,
  XVIOrderRendererComponent,
  XVIPriceInputRendererComponent,
  XVIUtcDateRendererComponent,
  XVISelectRendererComponent,
  XVITransferRendererComponent,
  XVITransferGroupRendererComponent,
  XVIStandWorksheetRendererComponent,
  XVILinkRendererComponent,
  XVIIntegerRendererComponent,
  XVIBufferedReferenceRenderer,
  CustomTextRendererComponent,
  IconsRendererComponent,
  XVICustomSelectRendererComponent,
  XVICountRendererComponent,
  XVIModalLinkRendererComponent,
  XVITransferGroupTemplateRendererComponent,
  XVIBellRendererComponent,
  CommonActionsRendererComponent,
  IconButtonRendererComponent,
} from './cell-renderer-components';
import { XVITagRendererComponent } from './cell-renderer-components/tag-renderer/tag-renderer.component';
import { XVIIncompleteTransferRendererComponent } from './cell-renderer-components/incomplete-transfer-actions-renderer/incomplete-transfer-actions-renderer.component';
import { XVIEntityGridFilterComponent } from './filter-components/entity-filter/entity-filter.component';
import {
  XVI_NO_ROWS_OVERLAY_COMPONENTS,
  XVI_NO_ROWS_OVERLAY_MAPPING,
} from './no-rows-overlay-components';
import { XVISpecificDataRenderer } from '@components/xvi-grid/custom-components/cell-renderer-components/specific-data-renderer/specific-data-renderer.component';
import { XVISiteHierarchyListButtonComponent } from '@components/xvi-grid/custom-components/hierarchy-list-button/hierarchy-list-button.component';
import { XVIHeaderIconRendererComponent } from '@components/xvi-grid/custom-components/header-icon-renderer/header-icon-renderer.component';
import { XVICustomSelectComponent } from '@components/xvi-grid/custom-components/custom-select/custom-select.component';
import { HintedTextRendererComponent } from './cell-renderer-components/hinted-text-renderer/hinted-text-renderer.component';
import { pick } from 'lodash';
import { XVIFilteredOrderRendererComponent } from './cell-renderer-components/filtered-order-actions-renderer/filtered-order-actions-renderer.component';
import { XVIFilteredTransferRendererComponent } from './cell-renderer-components/filtered-transfer-actions-renderer/filtered-transfer-actions-renderer.component';
import { XVITransferRequestRendererComponent } from './cell-renderer-components/transfer-request-actions-renderer/transfer-request-actions-renderer.component';
import { XVIPreparedStringRendererComponent } from './prepared-string-renderer/prepared-string-renderer.component';
import { BaseArrayStringRendererMenuComponent } from './cell-renderer-components/xvi-base-array-string-renderer/base-array-string-renderer-menu/base-array-string-renderer-menu.component';
import { XviBaseArrayStringRendererComponent } from './cell-renderer-components/xvi-base-array-string-renderer/xvi-base-array-string-renderer.component';
import { XviArrayStringRendererComponent } from './cell-renderer-components/xvi-array-string-renderer/xvi-array-string-renderer.component';
import { SwitchRendererComponent } from './cell-renderer-components/ag-grid-switch-renderer/switch-renderer.component';

export const customGridComponents = [
  XVIFloatInputRendererComponent,
  XVIInventoryCountRendererComponent,
  CustomTextRendererComponent,
  IconsRendererComponent,
  XVISelectRendererComponent,
  XVIOrderRendererComponent,
  XVIPriceInputRendererComponent,
  XVIUtcDateRendererComponent,
  XVITagRendererComponent,
  XVITransferRendererComponent,
  XVITransferGroupRendererComponent,
  XVITransferGroupTemplateRendererComponent,
  XVIStandWorksheetRendererComponent,
  XVILinkRendererComponent,
  XVIBellRendererComponent,
  XVIIntegerRendererComponent,
  XVIBufferedReferenceRenderer,
  XVISpecificDataRenderer,
  XVIEntityGridFilterComponent,
  XVISiteHierarchyListButtonComponent,
  XVIHeaderIconRendererComponent,
  XVIIncompleteTransferRendererComponent,
  XVICustomSelectRendererComponent,
  XVICustomSelectComponent,
  XVICountRendererComponent,
  HintedTextRendererComponent,
  XVIModalLinkRendererComponent,
  XVIFilteredOrderRendererComponent,
  XVIFilteredTransferRendererComponent,
  XVITransferRequestRendererComponent,
  XVIPreparedStringRendererComponent,
  BaseArrayStringRendererMenuComponent,
  XviBaseArrayStringRendererComponent,
  XviArrayStringRendererComponent,
  SwitchRendererComponent,
  CommonActionsRendererComponent,
  IconButtonRendererComponent,
  ...XVI_NO_ROWS_OVERLAY_COMPONENTS,
];

export const xviCustomGridFilters = {};

export const xviCustomGridRenderers = {
  floatInputRenderer: XVIFloatInputRendererComponent,
  selectRenderer: XVISelectRendererComponent,
  linkRenderer: XVILinkRendererComponent,
  bellRenderer: XVIBellRendererComponent,
  iconButtonRenderer: IconButtonRendererComponent,
  commonActionsRenderer: CommonActionsRendererComponent,
  orderActionsRenderer: XVIOrderRendererComponent,
  transferActionsRenderer: XVITransferRendererComponent,
  transferGroupActionsRenderer: XVITransferGroupRendererComponent,
  transferGroupTemplateActionsRenderer:
    XVITransferGroupTemplateRendererComponent,
  standWorksheetActionsRenderer: XVIStandWorksheetRendererComponent,
  siteInventoryCountActionsRenderer: XVIInventoryCountRendererComponent,
  priceInputRenderer: XVIPriceInputRendererComponent,
  utcDateRenderer: XVIUtcDateRendererComponent,
  tagRenderer: XVITagRendererComponent,
  integerRenderer: XVIIntegerRendererComponent,
  bufferedReferenceRenderer: XVIBufferedReferenceRenderer,
  specificDataRenderer: XVISpecificDataRenderer,
  entityFilter: XVIEntityGridFilterComponent,
  incompleteTransferActionsRenderer: XVIIncompleteTransferRendererComponent,
  customTextRenderer: CustomTextRendererComponent,
  iconsRenderer: IconsRendererComponent,
  customSelectRenderer: XVICustomSelectRendererComponent,
  countRenderer: XVICountRendererComponent,
  hintedTextRenderer: HintedTextRendererComponent,
  modalLinkRender: XVIModalLinkRendererComponent,
  filteredOrderActionsRender: XVIFilteredOrderRendererComponent,
  filteredTransferActionsRender: XVIFilteredTransferRendererComponent,
  transferRequestActionsRender: XVITransferRequestRendererComponent,
  preparedStringRenderer: XVIPreparedStringRendererComponent,
  arrayStringRenderer: XviArrayStringRendererComponent,
  switchRadioRenderer: SwitchRendererComponent,
};

export const xviCustomGridComponents = {
  // filters
  ...xviCustomGridFilters,

  // renderers
  ...xviCustomGridRenderers,

  // no rows overlay
  ...XVI_NO_ROWS_OVERLAY_MAPPING,
};

/**
 * all xvi need auto focus grid components
 */
export const xviKeyboardAutoFocusGridComponents = {
  ...pick(xviCustomGridRenderers, ['floatInputRenderer', 'integerRenderer']),
};
